import React, { useEffect } from 'react';
import '../App.css';
import Header from '../page/Header';
import HomeCover from '../page/HomeCover';
import AboutUsPage from '../page/AboutUsPage';
import ServicesPage from '../page/ServicesPage';
import Footer from '../page/Footer';
import ContactUsPage from '../page/ContactUsPage';
import CoursesInfo from '../page/CoursesInfo';
import Project from '../page/Project';
import Testimonial from '../page/Testimonial';

function Index() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Inline style for the container to manage spacing
  const sectionContainerStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '80px', // Adjust this value (e.g., 60px, 100px) to increase/decrease the gap
    width: '100%'
  };

  return (
    <>
      <Header />
      
      {/* We wrap the body content in a div with a gap */}
      <main style={sectionContainerStyle}>
        <HomeCover />
        <AboutUsPage />
        <ServicesPage />
        <Testimonial />
        {/* <Project /> */}
        <CoursesInfo />
        <ContactUsPage />
      </main>

      <Footer />
    </>
  );
}

export default Index;